module.exports = __webpack_public_path__ + "static/img/6.eb18c02.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/sp/6.png
// module id = lD1B
// module chunks = 0